/**
 * Created by ren on 18/07/2017.
 */
import * as ActionType from '../../constants/constant_action_types';

const INITIAL_STATE = {
  settings: {},
  pagination: {
    page    : 1,
    perPage : 10,
    lastPage:1,
  }
};

export default function inventoryTransferReducer( state = INITIAL_STATE, action ) {
  switch ( action.type ) {
    case ActionType.SET_INVENTORY_TRANSFER: {
      let result = {
        ...state, data: { ...action.data }
      };

      if ( action.settings ) {
        result = { ...result, settings: action.settings };
      }

      return result;
    }

    case ActionType.SET_INVENTORY_TRANSFER_PREFERENCES: {
      let result = { ...state };

      if ( action.settings ) {
        result = { ...result, settings: action.settings };
      }

      return result;
    }

    case ActionType.MASS_TRANSFER_IN_PROGRESS: {
      return {
        ...state, massTransferInProgress: true
      }
    }

    case ActionType.MASS_TRANSFER_DONE: {
      return {
        ...state, massTransferInProgress: false
      }
    }

    case ActionType.CLEAR_INVENTORY_TRANSFER: {
      return {
        ...INITIAL_STATE
      }
    }

    case ActionType.SET_TRANSFER_FORM_LINE_PAGINATION: {
      return {
        ...state, 
        pagination: action.pagination
      }
    }

    default:
      return state;
  }
}